import { useEffect, useState } from 'react';
import { IDataRequestSummary } from '@vivli/features/data-requests/infrastructure/interface';
import { first } from 'rxjs/operators';
import { useAssignedAppTypeContext, useDataRequestsApiContext } from '@vivli/core/infrastructure/context';

export function useDataRequestSummaries() {
    const [dataRequestSummaries, setDataRequestSummaries] = useState<IDataRequestSummary[]>();
    const [isLoadingDataRequestSummaries, setIsLoadingDataRequestSummaries] = useState(true);
    const assignedAppType = useAssignedAppTypeContext();
    const dataRequestsService = useDataRequestsApiContext();

    useEffect(() => {
        const dataRequestsSub = dataRequestsService
            .getDataRequestSummaries(assignedAppType.type)
            .pipe(first((dr) => dr !== null))
            .subscribe((dataRequests) => {
                setDataRequestSummaries(dataRequests);
                setIsLoadingDataRequestSummaries(false);
            });

        return () => {
            dataRequestsSub.unsubscribe();
        };
    }, []);

    return {
        dataRequestSummaries,
        isLoadingDataRequestSummaries,
    };
}
